import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { CreateQuizSchema } from './QuizManagementSchema';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { useDispatch, useSelector } from 'react-redux';
import PropagateLoader from "react-spinners/PropagateLoader";
import { questionListRes, questionListTodo } from '../../LMS_Redux/LMS_Slices/Quiz/QuestionList';
import { departmentListTodo } from '../../LMS_Redux/LMS_Slices/Assets/DepartmentList';
import Select from 'react-select'
import { addUpdateQuizRes, addUpdateQuizTodo } from '../../LMS_Redux/LMS_Slices/Quiz/AddUpdateQuiz';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

export default function CreateQuiz() {

    const { state } = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.questionList && state.questionList.data && state.questionList.data.data)
    const departmentList = useSelector(state => state.depratmentList && state.depratmentList.data && state.depratmentList.data.data)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const instructor_dept = []
    if (role == "Instructor") {
        instructor_dept.push({
            "value": userRole.dept_id,
            "label": userRole.vdepartment_name
        })
    }

    const [selectedOptions, setSelectedOptions] = useState(state ? state?.department_data : role == "Instructor" ? instructor_dept : []);

    var options = []

    const dept_list = departmentList && departmentList?.filter(val => val?.vstatus == 'Active')?.map((value) => options.push({
        "value": value.did,
        "label": value.vdepartment_name
    }))


    const handleSelectChange = (selected) => {
        let updatedSelectedOptions;

        if (selected && selected?.length && selected[selected?.length - 1].value === 'select-all') {
            // "Select All" option was clicked
            if (selectedOptions?.length === options?.length) {
                updatedSelectedOptions = [];
            } else {
                updatedSelectedOptions = options;
            }
        } else {
            updatedSelectedOptions = selected || [];
        }
        setSelectedOptions(updatedSelectedOptions);
        setLoading(true);
        setFieldValue('department', updatedSelectedOptions);
        dispatch(questionListTodo({ "department": updatedSelectedOptions, "status": 'active', "temp": '' })).then(() => question_res())
        setFieldValue("question", [])
    };

    const customOptions = [{ value: 'select-all', label: 'Select All' }, ...options];

    const initialValues = {
        id: state ? state.id : '',
        title: state ? state.quiz_title : '',
        department: selectedOptions || [],
        status: state ? state.status : '',
        question: [],
        old_question: state ? state.quiz_sub_schemas : []
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: CreateQuizSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addUpdateQuizTodo(values)).then(() => add_update_res())
        },
    })

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'QUESTIONS',
            field: 'question',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            width: 300
        },
        {
            headerName: `QUESTION ID`,
            field: 'id',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REMARK',
            field: 'remark',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => <span className={params.value == 'active' ? 'badge text-bg-success' : 'badge text-bg-danger'} style={{ textTransform: 'capitalize' }}>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
    ])

    const question_res = () => {
        if (questionListRes && questionListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const add_update_res = () => {
        // console.log(addUpdateQuizRes)
        if (addUpdateQuizRes && addUpdateQuizRes.success) {
            toast.success(addUpdateQuizRes.message, { position: "bottom-right" })
            setSpinner(false)
            setSelectedOptions([])
            setTimeout(() => {
                navigate('/quiz_list')
            }, 2000);

        } else {
            setSpinner(false)
            toast.error(addUpdateQuizRes.message, { position: "bottom-right" })
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(departmentListTodo())
        dispatch(questionListTodo({ "department": [], "status": 'active', "temp": '' })).then(() => question_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Quiz Management / </span>
                    {state ?
                        <Link to={"/quiz_list"}><span className='icon2'>Quiz List / </span></Link>
                        : ''
                    }
                    <span className='icon2'>{state ? "Edit" : "Create"} Quiz</span>
                </div>

                <div className='wrapper-admin'>

                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                        <div className="row">

                            {role !== "Instructor" ?
                                <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Permission Granted To</label>
                                        <Select
                                            closeMenuOnSelect={false}
                                            options={customOptions}
                                            // defaultValue={state ? state.department_data : role == "Instructor" ? instructor_dept : ''}
                                            value={values.department}
                                            onChange={handleSelectChange}
                                            onBlur={handleBlur}
                                            name='department'
                                            isMulti
                                            placeholder="Select Permission To"
                                            classNamePrefix="select"
                                            isDisabled={role === "Instructor" ? true : false}
                                            hideSelectedOptions={true}
                                            allowSelectAll={true}
                                        />
                                        {errors.department && touched.department ? (<span className='text-danger form_label'>{errors.department}</span>) : null}
                                    </div>

                                </div>
                                : ''
                            }

                            <div className="col-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label form_label">Add Title</label>
                                    <input type="text" className="form_input form-control" placeholder="Add Title"
                                        name='title' value={values.title || ''} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.title && touched.title ? (<span className='text-danger form_label'>{errors.title}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label form_label">Status</label>
                                    <select className="form-select form_input" aria-label="Default select example"
                                        name='status' value={values.status || ''} onChange={handleChange} onBlur={handleBlur}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                    {errors.status && touched.status ? (<span className='text-danger form_label'>{errors.status}</span>) : null}
                                </div>
                            </div>

                        </div>

                        {loading ?
                            <div className='text-center mb-3'>
                                <PropagateLoader
                                    color="#2262C6"
                                    size={20}
                                />
                            </div>
                            :
                            <>
                                <DataTables
                                    rowData={data}
                                    columnDefs={columnDefs}
                                    selection={true}
                                    value={setFieldValue}
                                    field={"question"}
                                    check={"multiple"}
                                    preSelected={state ? state.quiz_sub_schemas : ''}
                                    addQuizCheck={true}
                                />
                                {errors.question && touched.question ? (<span className='text-danger form_label' >{errors.question}</span>) : null}

                            </>
                        }

                        <div className='text-end mt-2'>
                            <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                {spinner ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className='ms-2'
                                    />
                                    : ''
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}